module.exports = __webpack_public_path__ + "img/logo-mew.f6482e98.svg";